//src/pages/CreatorAnalytics.jsx
import { useEffect, useState } from "react";
import API from "../services/api";

const CreatorAnalytics = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await API.get("/products/analytics/creator");
        setData(res.data);
      } catch (err) {
        console.error("Analytics error:", err);
      }
    };

    fetchAnalytics();
  }, []);

  if (!data) {
    return <h2>Loading analytics... ⏳</h2>;
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>📊 Creator Analytics</h1>

      <div
        style={{
          display: "flex",
          gap: 20,
          marginTop: 30,
          flexWrap: "wrap",
        }}
      >
        <Card
          title="💰 Total Earnings"
          value={`₦${data.total_earnings}`}
          color="#d4f8e8"
        />
        <Card
          title="🛒 Total Sales"
          value={data.total_sales}
          color="#dbeafe"
        />
        <Card
          title="📦 Total Products"
          value={data.total_products}
          color="#fef3c7"
        />
      </div>
    </div>
  );
};

const Card = ({ title, value, color }) => {
  return (
    <div
      style={{
        flex: "1 1 250px",
        padding: 25,
        borderRadius: 12,
        background: color,
        textAlign: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
      }}
    >
      <h3 style={{ marginBottom: 10 }}>{title}</h3>
      <h1>{value}</h1>
    </div>
  );
};

export default CreatorAnalytics;